export default __webpack_public_path__ + "static/media/OFFSITEAM.d9080986.svg";